export class ClassWatcher {
    constructor(target, classToWatch, classAddedCallback, classRemovedCallback) {
        this.target = target;
        this.classToWatch = classToWatch;
        this.classAddedCallback = classAddedCallback;
        this.classRemovedCallback = classRemovedCallback;
        this.lastClassState = this.target.classList.contains(classToWatch);
        this.observer = new MutationObserver(this.mutationCallback.bind(this));
    }
    observe() {
        this.observer.observe(this.target, { attributeFilter: ['class'] });
    }
    disconnect() {
        this.observer.disconnect();
    }
    mutationCallback(mutationRecords) {
        mutationRecords.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const currentClassState = mutation.target.classList.contains(this.classToWatch);
                if (currentClassState !== this.lastClassState) {
                    this.lastClassState = currentClassState;
                    if (currentClassState) {
                        this.classAddedCallback();
                    }
                    else {
                        this.classRemovedCallback();
                    }
                }
            }
        });
    }
}
